/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * Lifecycle state of an asset record.
 * @export
 * @enum {string}
 */
export type AssetStatus =
  'uploading' | 
  'processing' | 
  'ready' | 
  'failed'




export function AssetStatusFromJSON(json: any): AssetStatus {
    return AssetStatusFromJSONTyped(json, false);
}

export function AssetStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetStatus {
    return json;
}

export function AssetStatusToJSON(value?: AssetStatus | null): any {
    return value;
}

